import { FC, memo, useCallback } from "react";
import { showToast } from "@utils/showToast";
const ActionButton: FC = memo(() => {
    const handleClick = useCallback(() => {
        showToast("Soon", "success");
    }, []);

    return (
        <button
            onClick={handleClick}
            className="rounded-full border border-primary w-fit hover:bg-primary bg-primary/30 px-4 h-9 relative overflow-hidden"
        >
            Snipe
        </button>
    );
});

ActionButton.displayName = "ActionButton";

export default ActionButton;
